<template>
    <td 
        v-if="isExpanded"
        class="no_ellipsis text-center"
        role="button"
        tabindex="0"
    >							
        <v-icon 
            :alvqa="alvqa"
            small 
            class="ma-0 pa-0"
            :color="color"
        >fa-arrow-alt-circle-down</v-icon>
    </td>
    <td  
        v-else
        class="no_ellipsis text-center"
        role="button"
        tabindex="0"
    >
        <v-icon 
            :alvqa="alvqa"
            small 
            class="ma-0 pa-0"
            :color="color"
        >fa-arrow-alt-circle-right</v-icon>
    </td>
</template>

<script>
export default {
    name: "ExpandIcon",
    props: {
        isExpanded: Boolean,
        color: {
            type: String,
            default: "buttonStandard"
        },
        alvqa: {
            type: String,
            default: ""
        }
    }
}
</script>